import { Container, Typography, Button, Box } from '@mui/material';
import './NoPage.css';
import React from "react";
import { Link } from "react-router-dom";

function NoPage() {
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
        textAlign: "center",
      }}
    >
      <Box>
        <Typography variant="h1" sx={{ fontSize: "4rem", fontWeight: 700, color: "primary.main" }}>
          404
        </Typography>
        <Typography variant="h6" sx={{ mb: 2, color: "text.secondary" }}>
          Oops! The page you're looking for doesn't exist.
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          It might have been moved, or the URL could be incorrect. Please check the address or go back to the homepage.
        </Typography>
        <Button component={Link} to="/" variant="contained" color="primary">
          Go to Home
        </Button>
      </Box>
    </Container>
  );
}

export default NoPage;
